//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SiteVisitorDrawer from "./modules/SiteVisitorDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { queryUserTreeList as _queryUserTreeList } from '@/api/api';
export default {
  name: 'SiteVisitorList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    SiteVisitorDrawer: SiteVisitorDrawer
  },
  data: function data() {
    return {
      pagePath: '/om/site/visitor',
      pageTitle: '访客登记',
      addDisabled: false,
      userTree: [],
      // 表头
      isorter: {
        column: 'visitor_date',
        order: 'desc'
      },
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点名称',
        align: 'center',
        sorter: true
      },
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'visitorDate',
        colName: 'visitor_date',
        title: '来访时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'reportDate',
        colName: 'report_date',
        title: '报备时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '运维人员',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'visitorReason',
        colName: 'visitor_reason',
        title: '来访原因',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'visitorCompany',
        colName: 'visitor_company',
        title: '来访单位',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'visitorNum',
        colName: 'visitor_num',
        title: '来访人数',
        align: 'center',
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      console.log(value);
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];

      if (ids[0] == 1) {
        // 根据站点id
        this.addDisabled = false;
        this.queryParam.siteId = ids[1];
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.addDisabled = true;
        this.queryParam.siteId = undefined;
        this.spliceColumn(this.siteColumn, 1);
      }

      this.delayLoadData();
    }
  },
  created: function created() {
    this.queryUserTreeList();
    this.queryParam.status = 1;
  },
  computed: {},
  methods: {
    queryUserTreeList: function queryUserTreeList() {
      var _this = this;

      var that = this;
      that.userTree = []; // 用户

      _queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      });
    },
    handleAdd: function handleAdd() {
      var siteId = this.queryParam.siteId;
      this.$refs.modalForm.add(siteId);
      this.$refs.modalForm.title = '新增：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = false;
      this.$refs.modalForm.showContact = false;
    },
    // 新增/修改 成功时，重载列表
    modalFormOk: function modalFormOk() {
      var record = {};
      record.siteId = this.queryParam.siteId;
      this.queryParam = record;
      this.loadData();
    },
    onDateVisitorDate: function onDateVisitorDate(value, dateArray) {
      this.queryParam.visitorDateStart = dateArray[0];
      this.queryParam.visitorDateEnd = dateArray[1];
    },
    onDateReportDate: function onDateReportDate(value, dateArray) {
      this.queryParam.reportDateStart = dateArray[0];
      this.queryParam.reportDateEnd = dateArray[1];
    }
  }
};